var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"this-Part"},[_c('div',{staticClass:"this-Part-Play"},[_c('div',{staticClass:"this-Part-Text"},[_c('p',[_vm._v("➤"+_vm._s(_vm.$t('i.search.legalConstitution')))])]),_vm._v(" "),_c('div',{staticClass:"line"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d633154","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/search/components/law.vue
// module id = null
// module chunks = 